import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeMethodService {
  /*********************Properties*********************/
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor() { }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/
  protected padzero(n) {
    return n < 10 ? '0' + n : n;
  }
  protected pad2zeros(n) {
    if (n < 100) {
      n = '0' + n;
    }
    if (n < 10) {
      n = '0' + n;
    }
    return n;
  }
  /*********************Service Methods*********************/

  /*********************Private Methods*********************/
  calculateMinutesBasedOnTime(time) {
    //Hold index of colon(:)
    var indexOfColon = time.indexOf(":"); 
    //If AM/PM is specified, then hold index of space
    // e.g. if time format is '09:00 AM' then indexOfSpace have position index of space before 'AM'
    // else it will have -1 value
    var indexOfSpace = time.indexOf(" "); 
    //Hold hours value provided as part of time
    var hours = time.substring(0, indexOfColon); 
    //Hold minutes value provided as part of time
    var minutes;

    // If AM/PM is specified, index 2 will be not null
    // Also position of index should be  after colon(:)
    var index2;
    if (indexOfSpace !== null && indexOfSpace != -1 && indexOfSpace > indexOfColon) {
      minutes = time.substring(indexOfColon + 1, index2);
      //Hold meridian if provided
      var mer = time.substring(indexOfSpace + 1, time.length);

      //Calculate hours if meridian is provided
      if (mer != null && (mer == "PM" || mer == "pm")) {
        hours = parseInt(hours) + 12;
      }
    }
    else {
      minutes = time.substring(indexOfColon + 1, time.length);
    }

    return parseInt(minutes) * 60 + hours * 3600;
  }

  private getHours(time) {

    //Hold index of colon(:)
    var indexOfColon = time.indexOf(":");

    //If AM/PM is specified, then hold index of space
    // e.g. if time format is '09:00 AM' then indexOfSpace have position index of space before 'AM'
    // else it will have -1 value
    var indexOfSpace = time.indexOf(" ");

    //Hold hours value provided as part of time
    var hours = time.substring(0, indexOfColon);


    var index2;
    var minutes;
    // If AM/PM is specified, index 2 will be not null
    // Also position of index should be  after colon(:)
    if (indexOfSpace !== null && indexOfSpace != -1 && indexOfSpace > indexOfColon) {
      minutes = time.substring(indexOfColon + 1, index2);
      //Hold meridian if provided
      var mer = time.substring(indexOfSpace + 1, time.length);

      //Calculate hours if meridian is provided
      if (mer != null && (mer == "PM" || mer == "pm")) {
        hours = parseInt(hours) + 12;
      }
    }

    minutes = time.substring(indexOfColon + 1, time.length);

    return hours;
  }

  private getMinutes(time) {

    //Hold index of colon(:)
    var indexOfColon = time.indexOf(":");

    //If AM/PM is specified, then hold index of space
    // e.g. if time format is '09:00 AM' then indexOfSpace have position index of space before 'AM'
    // else it will have -1 value
    var indexOfSpace = time.indexOf(" ");


    //Hold minutes value provided as part of time
    var minutes;

    minutes = time.substring(indexOfColon + 1, time.length);

    return minutes;
  }

  //Function to return time in HH:MM format
  private getHoursAndMinutes(value) {
    var hours = Math.floor(value / 60);
    var minutes = value - (hours * 60);

    let hr, min;
    if (hours < 10) hr = "0" + hours.toString();
    if (hours === 0) hr = '00';

    if (minutes < 10) min = "0" + minutes.toString();
    if (minutes === 0) min = '00';
    return hr + ':' + min;
  }

  private toISOString(date) {
    return date.getFullYear() + '-' + this.padzero(date.getMonth() + 1) + '-' + this.padzero(date.getDate())
      + 'T' + this.padzero(date.getHours()) + ':' + this.padzero(date.getMinutes()) + ':' + this.padzero(date.getSeconds()) + '.' + this.pad2zeros(date.getMilliseconds())
      + 'Z';
  }

  private getNumberSuffix(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }
  /*********************Private Methods*********************/




}
